export default {
  name: 'RenderComponent',
  props: ['data'],
  data() {
    return {};
  },
  render() {
    return this.data;
  },
};
